<div
  class="section-authentication-signin vh-100 d-flex justify-content-center align-items-center my-sm-5 my-2"
>
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6 d-none d-lg-block">
        <img
          src="assets/images/cdblack.png"
          alt="Login Image"
          class="img-fluid"
        />
      </div>

      <div class="col-lg-6 col-md-8 col-sm-12 col-12 mx-auto">
        <div class="card shadow-lg mycardpadding mb-0">
          <div class="d-lg-none d-block mt-sm-2 mt-0 mb-3 mylogoimg">
            <img
              src="assets/images/cdblack.png"
              alt="Login Image"
              class="img-fluid"
            />
          </div>
          <div class="text-center mb-4">
            <h5 class="">Sign up for your account ✅</h5>
          </div>
          <div class="form-body">
            <p>
              <form-error [form]="form"></form-error>
            </p>
            <div *ngIf="isLogin" class="alert alert-success text-center">
              <p>Account created successfully!</p>
              <a routerLink="/login" style="color: #1191fa">Sign in here</a>
            </div>
            <form class="row g-3" *ngIf="!isLogin" #signupform="ngForm">
              <div class="col-12">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>First Name</mat-label>
                  <input
                    matInput
                    type="text"
                    id="firstName"
                    name="firstName"
                    required
                    [(ngModel)]="form.data['firstName']"
                    #firstName="ngModel"
                  />
                  <mat-icon matPrefix class="opacity-50">person</mat-icon>
                </mat-form-field>

                <mat-error
                  *ngIf="firstName.errors?.['required'] && firstName.touched"
                >
                  First Name is required
                </mat-error>

                <mat-error
                  *ngIf="firstName.errors?.['pattern'] && firstName.touched"
                >
                  First Name cannot contain only spaces
                </mat-error>
              </div>

              <div class="col-12">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Last Name</mat-label>
                  <input
                    matInput
                    type="text"
                    id="lastName"
                    name="lastName"
                    required
                    [(ngModel)]="form.data['lastName']"
                    #lastName="ngModel"
                  />
                  <mat-icon matPrefix class="opacity-50"
                    >person_outline</mat-icon
                  >
                </mat-form-field>

                <mat-error
                  *ngIf="lastName.errors?.['required'] && lastName.touched"
                >
                  Last Name is required
                </mat-error>

                <mat-error
                  *ngIf="lastName.errors?.['pattern'] && lastName.touched"
                >
                  Last Name cannot contain only spaces
                </mat-error>
              </div>

              <div class="col-12">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Email</mat-label>
                  <input
                    matInput
                    type="email"
                    [pattern]="emailPattern"
                    name="loginId"
                    id="login"
                    required
                    [(ngModel)]="form.data['loginId']"
                    #login="ngModel"
                  />
                  <mat-icon matPrefix class="opacity-50">email</mat-icon>

                  <mat-error *ngIf="login.errors?.['pattern']">
                    Please enter a valid email
                  </mat-error>
                  <mat-error *ngIf="login.errors?.['required']">
                    Email is required
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col-12">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Password</mat-label>
                  <input
                    matInput
                    [type]="showPassword ? 'text' : 'password'"
                    name="password"
                    id="inputChoosePassword"
                    [(ngModel)]="form.data['password']"
                    required
                    #password="ngModel"
                  />
                  <mat-icon matPrefix class="opacity-50">lock_open</mat-icon>

                  <button
                    type="button"
                    mat-icon-button
                    matSuffix
                    (click)="togglePasswordVisibility()"
                    aria-label="Toggle password visibility"
                  >
                    <mat-icon class="text-secondary">
                      {{ showPassword ? "visibility" : "visibility_off" }}
                    </mat-icon>
                  </button>
                </mat-form-field>

                <mat-error
                  *ngIf="password.errors?.['required'] && password.touched"
                >
                  Password is required
                </mat-error>

                <mat-error
                  *ngIf="password.errors?.['pattern'] && password.touched"
                >
                  Password cannot contain only spaces
                </mat-error>
              </div>

              <div class="col-12 mb-3">
                <div class="d-grid">
                  <button
                    mat-raised-button
                    color="primary"
                    type="submit"
                    (click)="signup()"
                    [disabled]="!signupform.valid"
                    class="w-100 fat-button shadow-sm"
                  >
                    <span class="fs-6 tracking-wider">Sign Up</span>
                  </button>
                </div>
              </div>
              <div class="col-12">
                <div class="text-center">
                  <p class="stay-connect mb-0">
                    Already have an account?
                    <a
                      routerLink="/login"
                      class="text-decoration-none fw-bold ms-1"
                      style="color: #3f51b5"
                      >Sign in here</a
                    >
                  </p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!--end row-->
  </div>
</div>
